import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import styles from './safeAndSecureModule.module.scss';
import SafeAndSecureBenefits from '../safeAndSecureBenefits/safeAndSecureBenefits';

export default function SafeAndSecureModule({
  title = '',
  icon = null,
  description = '',
  benefits = {},
}) {
  return (
    <div className={styles.descriptionWrapper}>
      <div className={styles.content}>
        <Grid container>
          <Grid item xs={12} sm={6} lg={6}>
            <div className={styles.history}>
              {icon && (
                <img
                  src={icon.path}
                  className={styles.icon}
                  loading="lazy"
                  alt={icon.alt}
                  {...{
                    ...(icon.width && {
                      width: icon.width,
                    }),
                    ...(icon.height && {
                      height: icon.height,
                    }),
                  }}
                />
              )}
              <div className={styles.title}>{parse(`${title}`)}</div>
              <div />
              <div className={styles.description}>
                {parse(`${description}`)}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={1} lg={1}>
            <div className={styles.divider} />
          </Grid>
          <Grid item xs={12} sm={5} lg={5}>
            <div className={styles.helper}>
              <SafeAndSecureBenefits {...benefits} />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

SafeAndSecureModule.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
  }),
  benefits: PropTypes.object,
};
